export default [
  {
    path: '/notifications',
    name: 'notifications-index',
    component: () => import('./index.vue'),
    meta: {
      public: false,
      title: "notifications.Bildirimler",
    },
  },
  {
    path: '/notifications/send',
    name: 'notifications-send',
    component: () => import('./Gonder.vue'),
    meta: {
      public: false,
      pageTitle: "notifications.Bildirim Gönder",
      yetki: { k: [1150002] },
      breadcrumb: [
        {
          title: 'notifications.Admin',
        },
        {
          title: 'notifications.Bildirimler',
        },
        {
          title: 'notifications.Gönder',
          active: true,
        },
      ],
    },
  },
]
